import type { UserProfile } from "epsm-api-types/models";

export const getDirtyValues = (
	dirtyFields: Partial<Record<keyof UserProfile, unknown>>,
	allValues: Partial<UserProfile>,
): Partial<UserProfile> => {
	if (!dirtyFields) {
		return {};
	}

	return Object.fromEntries(
		Object.entries(dirtyFields)
			.filter(([_, value]) => value !== undefined)
			.map(([key, value]) => {
				const typedKey = key as keyof UserProfile;
				const fieldValue = allValues[typedKey];

				if (typeof value === "object" && value !== null) {
					return [
						typedKey,
						getDirtyValues(value, fieldValue as Partial<UserProfile>),
					];
				}
				return [typedKey, fieldValue];
			}),
	);
};
